import React, {useState, useEffect, useContext, useRef} from "react";
import {useParams} from "react-router-dom";
import ListPanel from '../administration/components/ListPanel';
import EditPanel from '../administration/components/EditPanel';
import {useHistory} from 'react-router-dom';
import {store} from '../../context/store';
import {INPUT_TYPE_TEXTAREA} from "../../constants/input-types";
import {functions} from "../../constants/common-functions";
import {STRINGIFY} from "../../constants/general-constants";
import {DEFAULT_BLUE} from "../../constants/general-constants";
import Header from "../../components/Header";
import LeftMenu from "../../components/LeftMenu";

export default function AdministrationResourcesEdit(){
	
	const globalState = useContext(store);
	const history = useHistory(); 
	const [entityDescription, setEntityDescription] = useState("");
	const [thisResource, setThisResource] = useState({});

	const refDescription = useRef(null);
	
	const id = useParams()["id"];

	
	useEffect(() => {
		functions.getObjectFromAjax("/resolution/getsimpleresource?id=" + id, null, initialiseFields);
	}, [id]);
	
	
	
	const initialiseFields = (entity) => {
		setThisResource(entity);
		try{
			setEntityDescription(entity.title);
			refDescription.current.value = entity.title;
	
		}
		catch(e){}
		
	};
	
	const mainComponentRows = [
		{ref:refDescription, id:"1", title:"Description", inputType:INPUT_TYPE_TEXTAREA}
	];
	
	const thisContainer = {
		display:"flex",
		width:"calc(100% - 60px)",
		minHeight:"100vh",
		backgroundColor:"white",
		flexDirection:"column",
		//overflow:"auto",
		paddingBottom:"100px",
		marginLeft:"60px",
		marginTop:"60px"
	};
	
	const administrationHeader = {
		display:"flex",
		height:"60px",
		paddingLeft:"20px",
		alignItems:"center",
		color:"black"
	};
	
	const contentPanel = {
		display:"flex",
		width:"100%"
	};
	
	const editFooter = {
		display:"flex",
		height:"80px",
		width:"calc(100% - 60px)",
		position:"fixed",
		bottom:"0px",
		left:"60px",
		backgroundColor:"black",
		justifyContent:"space-around",
		alignItems:'center'
	};
	
	const editButtonContainer = {
		display:"flex"
	};
	
	const editButton = {
		display:"flex",
		width:"200px",
		height:"40px",
		borderRadius:"4px",
		alignItems:"center",
		color:'white',
		fontSize:"14px",
		justifyContent:"space-around",
		cursor:'pointer',
		border:"1px solid " +DEFAULT_BLUE,
		margin:"5px"
	};
	
	const getSubmitObject = () => {
		let submitObject = thisResource;
		submitObject.title = refDescription.current.value;
		return submitObject
	}
	
	const goSubmit = () => {
		
		functions.submitAjax("/resolution/simpleresourcesave", 
				getSubmitObject(), saveEnd,  STRINGIFY, handleSubmitError);
		
	};
	
	const handleSubmitError = (e) => {
		console.log(e);
	};
	
	const saveEnd = () => {
		goCancel();
	};
	
	const goDelete = () => {
		functions.submitAjax("/resolution/simpleresourcedelete", 
				getSubmitObject(), saveEnd,  STRINGIFY, handleSubmitError);
	};
	
	const goCancel = () => {
		history.goBack();
	};

	return (
		
			<div style={thisContainer}>
			<Header/>
				<LeftMenu/>
				<div style={administrationHeader}>
					Resource Edit
				</div>
				<div style={contentPanel}>
					<EditPanel
					title="Main Details"
						componentRows = {mainComponentRows}
					/>
				</div>
				<div style={editFooter}>
				<div style={editButtonContainer}>
					<div style={editButton} onClick={goSubmit}>
						Save
					</div>
					<div style={editButton} onClick={goDelete}>
						Delete
					</div>
					<div style={editButton} onClick={goCancel}>
						Cancel
					</div>
				</div>
			</div>
			</div>
			
	
	);
}